<template>
  <div class="-space-y-px rounded-md bg-white">
    <div class="text-base font-semibold leading-6 text-gray-900 py-2">
      {{ showMultiLingualText(data?.question, null, false, $i18n.locale) }}
    </div>

    <FormRadioInputOption 
      v-for="option in (data?.options || [])" 
      :key="option.id"
      :option="option"
      :data="data"
      :value="getCurrentValue()"
      :disabled="disabled"
      @change="handleOptionChange"
    />
    
    <!-- Fallback for missing options -->
    <div v-if="!data?.options || data.options.length === 0" class="text-red-500 text-sm p-2">
      No options available for this question
    </div>
  </div>
</template>

<script>
import FormRadioInputOption from './FormRadioInputOption.vue'
import { showMultiLingualText } from '../../utils/languageUtils.js'

export default {
  name: 'FormRadioInput',
  components: {
    FormRadioInputOption
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    value: {
      type: [String, Number],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => ({})
    },
    getQuizAnswer: {
      type: Function,
      default: null
    },
    handleChangeElement: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      showMultiLingualText
    }
  },
  mounted() {
    console.log('FormRadioInput mounted:', {
      disabled: this.disabled,
      value: this.value,
      dataExists: !!this.data,
      optionsCount: this.data?.options?.length || 0
    })
  },
  
  watch: {
    disabled: {
      handler(newValue, oldValue) {
        console.log('FormRadioInput disabled changed:', {
          oldValue,
          newValue
        })
      },
      immediate: true
    },
    
    data: {
      handler(newValue, oldValue) {
        console.log('FormRadioInput data changed:', {
          oldValue: !!oldValue,
          newValue: !!newValue,
          optionsCount: newValue?.options?.length || 0
        })
      },
      immediate: true
    }
  },
  methods: {
    getCurrentValue() {
      // Get the current answer for this question
      const questionId = this.data?.id?.toString()
      console.log('FormRadioInput: getCurrentValue called for questionId:', questionId)
      
      if (!questionId) {
        console.log('FormRadioInput: No questionId found, returning null')
        return null
      }
      
      // First check local form state
      if (this.form.quiz_answers && this.form.quiz_answers[questionId]) {
        const formValue = this.form.quiz_answers[questionId]
        console.log('FormRadioInput: Found value in form state:', formValue)
        return formValue
      }
      
      // Then check via getQuizAnswer function if available
      if (this.getQuizAnswer) {
        const quizValue = this.getQuizAnswer({ type: 'form_radio_input', data: this.data })
        console.log('FormRadioInput: Found value via getQuizAnswer:', quizValue)
        return quizValue
      }
      
      console.log('FormRadioInput: No value found, returning null')
      return null
    },
    
    handleOptionChange(event) {
      console.log('FormRadioInput: Option changed:', event)
      console.log('FormRadioInput: Event target:', event.target)
      console.log('FormRadioInput: Event target name:', event.target?.name)
      console.log('FormRadioInput: Event target value:', event.target?.value)
      console.log('FormRadioInput: handleChangeElement function exists:', !!this.handleChangeElement)
      
      // Call the handleChangeElement function if provided
      if (this.handleChangeElement) {
        console.log('FormRadioInput: Calling handleChangeElement')
        this.handleChangeElement(event)
      } else {
        console.log('FormRadioInput: No handleChangeElement function provided')
      }
      
      // Also emit the change event for backward compatibility
      this.$emit('change', event)
    }
  }
}
</script> 